import { Injectable } from "@angular/core";
import { Marketplace } from "@front/m19-api-client";
import { Marketplaces } from "@front/m19-models";
import { DateTime } from "luxon";

@Injectable({
  providedIn: "root",
})
export class AmazonTimezoneService {
  public getNow(marketplace: Marketplace): DateTime {
    return DateTime.now().setZone(Marketplaces[marketplace]?.timeZone ?? "Europe/Paris");
  }
}
